import { Navigate } from "react-router-dom";
import { isStandaloneDisplayMode } from "../../pwa/pwaDetection";

/** Installed home-screen app → login. Browser tab → normal public home. */
export default function PwaRootLanding({ browserElement }) {
  if (isStandaloneDisplayMode()) {
    return <Navigate to="/login" replace />;
  }
  return browserElement;
}
